import React from 'react';
import { Col, Card, CardHeader, CardBody } from 'reactstrap';
import SimpleBar from 'simplebar-react';

const RecentActivities = React.memo(({ attendanceLogs }) => {
  return (
    <React.Fragment>
      <Col xl={4} lg={4} md={4} sm={12}>
        <Card>
          <CardHeader className="d-flex justify-content-between align-items-center bg-white">
            <h6 className="card-title mt-2">Recent Activity</h6>
          </CardHeader>

          <CardBody className="p-0">
            {/* SimpleBar for scrollable content */}
            <SimpleBar className="p-3">
              {attendanceLogs.length > 0 ? (
                <ul className="list-unstyled mb-0">
                  {/* Render activity logs dynamically */}
                  {attendanceLogs.map((log) => (
                    <li
                      className="activity-list activity-border pb-3"
                      key={log.id}
                    >
                      <div className="d-flex">
                        {/* Activity Icon */}
                        <div
                          className="activity-icon d-flex align-items-center justify-content-center"
                          style={{
                            width: '55px',
                            height: '55px',
                            borderRadius: '50%',
                          }}
                        >
                          <span
                            className="avatar text-white rounded-circle d-flex align-items-center justify-content-center"
                            style={{
                              width: '40px',
                              height: '40px',
                              backgroundColor:
                                log.type === 'checkin' || log.type === 'breakin'
                                  ? '#ffefd5'
                                  : '#B9BBE5',
                            }}
                          >
                            <span
                              style={{
                                color: '#495057',
                                fontWeight: '700',
                                fontSize: 10,
                              }}
                            >
                              {log.type === 'checkin'
                                ? 'IN'
                                : log.type === 'checkout'
                                ? 'OUT'
                                : log.type === 'breakin'
                                ? 'BRIN'
                                : log.type === 'breakout'
                                ? 'BROUT'
                                : 'N/A'}
                            </span>
                          </span>
                        </div>

                        {/* Activity Content */}
                        <div className="ms-3 mt-1">
                          <h6 className="mb-1">
                            {new Date(log.updatedAt).toLocaleString()}
                          </h6>
                          <p className="text-muted mb-0 adjust-fs">
                            {log.associate?.first_name || 'N/A'}{' '}
                            {log.associate?.last_name || ''}
                          </p>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <h6 className="text-muted text-center py-3">
                  No attendance logs available.
                </h6>
              )}
            </SimpleBar>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
});

export default RecentActivities;
